export default "__VITE_ASSET__BDx6Bmy5__"